import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'

import { ORDER } from './constants'

function RankingsBoxTableDetailsHeaderCell({ keyName, onSort, sort }) {
  const { t: translate } = useTranslation()

  return (
    <Box
      className={classNames('cell cursor-pointer', `cell-${keyName}`, {
        active: sort.sortBy === keyName,
        asc: sort.order === ORDER.ASC,
      })}
      onClick={() => onSort(keyName)}
    >
      {translate(`rankings.${keyName}`)}
    </Box>
  )
}

RankingsBoxTableDetailsHeaderCell.propTypes = {
  keyName: PropTypes.string,
  onSort: PropTypes.func,
  sort: PropTypes.shape({
    order: PropTypes.oneOf([ORDER.ASC, ORDER.DESC]),
    sortBy: PropTypes.string,
  }),
}

export default RankingsBoxTableDetailsHeaderCell
